import { EligibilityCheckPatientScheduleWebhookStruct } from "../../structs/orchestrator-schedule/eligibility-check-patient-schedule-webhook.struct";

export class EligibilityCheckPatientScheduleRequest {
    public body: EligibilityCheckPatientScheduleWebhookStruct = new EligibilityCheckPatientScheduleWebhookStruct();
}